export default [
    {
        "id": "footer-1",
        "plugin": null,
        "pluginId": null,
        "name": null,
        "relatedBanner": "LogisticsPartners",
        "relatedBanner2": "PaymentOperators",
        "html": require('./footers/footer-1/html').default,
        "css": require('./footers/footer-1/css').default,
        "cssTablet": require('./footers/footer-1/cssTablet').default,
        "cssMobile": require('./footers/footer-1/cssMobile').default,
        "scss": require('./footers/footer-1/scss').default,
        "scssTablet": require('./footers/footer-1/scssTablet').default,
        "scssMobile": require('./footers/footer-1/scssMobile').default,
		"js": require('./footers/footer-1/js').default,
        "minJs": require('./footers/footer-1/minJs').default,
		"svgContent": require('./footers/footer-1/svgContent').default,
		"svgViewBox": "0 0 1440 533",
		"svgContentMobile": require('./footers/footer-1/svgContentMobile').default,
		"svgViewBoxMobile": "0 0 360 698"
    }
]